<template>
  <v-dialog v-model="videoDialog" max-width="800px">
    <v-card>
      <v-card-title>Video</v-card-title>
      <v-card-text>
        <p class="video-hint">Supported: YouTube, Google Drive, Facebook, Instagram, TikTok, Vimeo, Dailymotion, Twitch, Twitter, Rumble, Odysee, Bilibili.</p>
        <iframe
          v-if="currentVideoUrl"
          :src="currentVideoUrl"
          width="100%"
          height="400px"
          frameborder="0"
          allowfullscreen
          @load="showFullScreenHint"
        ></iframe>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" text @click="closeVideo">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    videoUrl: String,
  },
  data() {
    return {
      videoDialog: false,
      currentVideoUrl: null,
    };
  },
  watch: {
    videoUrl: {
      immediate: true,
      handler(newUrl) {
        if (newUrl) {
          this.currentVideoUrl = this.getEmbedUrl(newUrl);
          if (this.currentVideoUrl) {
            this.videoDialog = true;
          } else {
            alert("Invalid or unsupported video URL.");
          }
        }
      },
    },
  },
  methods: {
    closeVideo() {
      this.videoDialog = false;
      this.$emit("close");
    },
    getEmbedUrl(url) {
      const patterns = [
        { regex: /youtube\.com\/watch\?v=([\w-]+)/, embed: "https://www.youtube.com/embed/$1" },
        { regex: /youtu\.be\/([\w-]+)/, embed: "https://www.youtube.com/embed/$1" },
        { regex: /drive\.google\.com\/file\/d\/([\w-]+)/, embed: "https://drive.google.com/file/d/$1/preview" },
        { regex: /facebook\.com\/.*\/videos\/([\d]+)/, embed: "https://www.facebook.com/video/embed?video_id=$1" },
        { regex: /facebook\.com\/reel\/([\d]+)/, embed: "https://www.facebook.com/video/embed?video_id=$1" },
        { regex: /instagram\.com\/reel\/([\w-]+)/, embed: "https://www.instagram.com/reel/$1/embed" },
        { regex: /instagram\.com\/p\/([\w-]+)/, embed: "https://www.instagram.com/p/$1/embed" },
        { regex: /tiktok\.com\/@?[\w.-]+\/video\/([\d]+)/, embed: "https://www.tiktok.com/embed/v2/$1" },
        { regex: /vimeo\.com\/([\d]+)/, embed: "https://player.vimeo.com/video/$1" },
        { regex: /dailymotion\.com\/video\/([\w]+)/, embed: "https://www.dailymotion.com/embed/video/$1" },
        { regex: /twitch\.tv\/videos\/([\d]+)/, embed: "https://player.twitch.tv/?video=$1&parent=yourdomain.com" },
        { regex: /twitter\.com\/.*\/status\/([\d]+)/, embed: "https://twitframe.com/show?url=https://twitter.com/i/status/$1" },
        { regex: /rumble\.com\/.*\/([\w-]+)/, embed: "https://rumble.com/embed/$1/" },
        { regex: /odysee\.com\/\$\/embed\/([\w-]+)/, embed: "https://odysee.com/$/embed/$1" },
        { regex: /bilibili\.com\/video\/([\w]+)/, embed: "https://player.bilibili.com/player.html?bvid=$1" },
      ];
      
      for (const { regex, embed } of patterns) {
        const match = url.match(regex);
        if (match) {
          return embed.replace("$1", match[1]);
        }
      }
      return null;
    },
    showFullScreenHint() {
      alert("For best experience, open the video in full screen mode.");
    },
  },
};
</script>

<style>
.video-hint {
  font-size: 12px;
  color: gray;
  margin-bottom: 10px;
}
</style>
